import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import Head from "next/head";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "src/hooks/use-auth";
import { selectPublicPlans } from "src/slices/system/selectors";
import { getPlans } from "src/slices/system/thunks";
import BookACall from "./bookACall";
import { PricingPlan } from "./pricing-plan";
type Props = {};

const Pricing = (props: Props) => {
  const allPublicPlans = useSelector(selectPublicPlans);
  const [planType, setPlanType] = useState("yearly");
  const { user } = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPlans());
  }, []);

  const monthlyPlans = allPublicPlans.filter(
    (plan) => Number(plan.billingInterval) <= 31
  );

  const yearlyPlans = allPublicPlans.filter(
    (plan) => Number(plan.billingInterval) === 365
  );

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    planType: string
  ) => {
    if (planType) setPlanType(planType);
  };

  const plans = planType === "monthly" ? monthlyPlans : yearlyPlans;
  let planEndDate = "";
  try {
    planEndDate = (user?.plan?.next_bill_date).split("-").reverse().join("-");
  } catch (e) {
    planEndDate = "Until Your Current Plan Expires";
  }
  return (
    <>
      <Head>
        <title>Pricing | SEOwind.io</title>
      </Head>
      <Box
        component="main"
        sx={{
          backgroundColor: "background.paper",
          flexGrow: 1,
          pb: 6,
        }}
      >
        {/* sticking bar component */}

        {user?.plan?.isCancelled && (
          <Container maxWidth="lg" sx={{}}>
            <AppBar position="static">
              <Toolbar
                variant="dense"
                sx={{
                  justifyContent: "center",
                }}
              >
                <Typography variant="body2" color="inherit" component="div">
                  You have cancelled your subscription. You can still use the
                  platform until {planEndDate}.
                </Typography>
              </Toolbar>
            </AppBar>
          </Container>
        )}

        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Box display="flex" justifyContent="center">
            <ToggleButtonGroup
              sx={{ ml: 2 }}
              color="primary"
              value={planType}
              exclusive
              onChange={handleChange}
              aria-label="Platform"
            >
              <ToggleButton value="monthly">Monthly</ToggleButton>
              <ToggleButton value="yearly">Yearly</ToggleButton>
            </ToggleButtonGroup>
          </Box>
          <Grid
            container
            spacing={4}
            sx={{
              mt: 3,
            }}
          >
            {plans.map((plan, index) => (
              <Grid item md={4} xs={12} key={plan.name}>
                <PricingPlan
                  {...plan}
                  index={index}
                  planType={planType}
                  sx={{
                    height: "100%",
                    maxWidth: 460,
                    mx: "auto",
                  }}
                />
              </Grid>
            ))}
          </Grid>
          <Typography
            sx={{
              mt: 4,
              textAlign: "center",
              color: "text.secondary",
            }}
          >
            *The 3-day trial includes updating or writing 2 articles using AI.
            All plans are subject to our{" "}
            <a
              href="https://seowind.io/terms/#fair-use-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Fair Use Policy
            </a>
          </Typography>
          {/* Calendly Link */}
          <BookACall />
        </Container>
      </Box>
    </>
  );
};

export default Pricing;
